(function (angular) {
    'use strict';

    angular.module('mobilezuz').controller('LimitExceedWarningCtrl', LimitExceedWarningCtrl);

    LimitExceedWarningCtrl.$inject = ['$state','$mdDialog', '$filter', 'PermanentFilters','Cart', 'DELIVERY_MODE_TOGGLE', 'Config', 'SP_SERVICES', 'isShowSwitchToScheduledDelivery', 'Util'];

    function LimitExceedWarningCtrl($state,$mdDialog, $filter, PermanentFilters, Cart, DELIVERY_MODE_TOGGLE, Config, SP_SERVICES, isShowSwitchToScheduledDelivery, Util) {
        var limitExceedWarningCtrl = this,
            _translate = $filter('translate');

        angular.extend(limitExceedWarningCtrl, {
            itemLimitExceededMessageAtCheckout: {},
            itemLimitExceededWarning: {},
            languageId: Config.language.id,
            isShowSwitchToScheduledDelivery: isShowSwitchToScheduledDelivery,
            deliveryType: _translate('delivery_mode_' + DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP),
            adjustCartAndCloseDialog: adjustCartAndCloseDialog,
            switchToScheduledDelivery: switchToScheduledDelivery,
            replaceParams: replaceParams,
            closePopUp: closePopUp,
        });

        Config.waitForInit().then(function () {
            if (Config.retailer.settings) {
                limitExceedWarningCtrl.itemLimitExceededMessageAtCheckout = Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededMessageAtCheckout || {};
                limitExceedWarningCtrl.itemLimitExceededWarning = Util.tryParseJson(Config.retailer.settings.productLimitInCart).itemLimitExceededWarning || {};
            }
        });
        function closePopUp () {
            $mdDialog.hide();
        }

        function adjustCartAndCloseDialog() {
            $mdDialog.hide({isChangeExpressDelivery: true});
            if (!limitExceedWarningCtrl.isShowSwitchToScheduledDelivery) {
                $state.go('app.cart');
            }
        }

        function changeBranchArea() {
            var newDeliveryTypeId = SP_SERVICES.DELIVERY_TYPES.DELIVERY;
            var newArea = !!Config.branch && (Config.branch.areas || []).find(function (area) {
                return area.deliveryTypeId === newDeliveryTypeId;
            });

            if (newArea) {
                Config.changeBranch(Config.branch.id, newArea.id, {});
                localStorage.setItem('mobileZuzModeToggle', DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP);
                PermanentFilters.addProductTagsFilters([], true);
            }
        }

        function switchToScheduledDelivery() {
            $mdDialog.hide({isSwitchToDelivery: true});
            changeBranchArea();
        }

        function replaceParams() {
            var template = limitExceedWarningCtrl.itemLimitExceededMessageAtCheckout.popUpMessage[limitExceedWarningCtrl.languageId];
        
            if (!template) {
                return;
            }
        
            var params = {
                '{Product Amount in the Cart}': Cart.total.lines,
                '{Product Amount Limit}': limitExceedWarningCtrl.itemLimitExceededWarning.maxProduct || '',
                '{delivery type}': _translate('delivery_mode_' + DELIVERY_MODE_TOGGLE.SCHEDULED_DELIVERY_PICKUP)
            };
        
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var regex = new RegExp(key, 'g');
                    template = template.replace(regex, params[key]);
                }
            }
        
            return template;
        }
        
    }
})(angular);